/*
 * UserQuestionnaire Messages
 *
 * This contains all the text for the UserQuestionnaire component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.UserQuestionnaire';

export default defineMessages({
  qProgress: {
    id: `${scope}.qProgress`,
    defaultMessage: 'Questionnaire progress',
  },
  complete: {
    id: `${scope}.complete`,
    defaultMessage: 'Complete',
  },
});
